<template>
  <el-dialog
    title="Patient Address Required for taxable items"
    v-model="dialogVisible"
    class="express-checkout-patient-address-ppl order-test"
    :close-on-click-modal="true"
    @close="close"
    > 

    <p class="inform-text mb-4 mx-5">{{ `${isSelectedTaxableTest.join(', ')} is taxable.` }}</p>
    <p class="inform-text mx-5">{{ $t("OrderPage[\"We require the patient’s address to properly calculate the price.\"]") }}</p>


    <template v-slot:footer>
    <span class="flex justify-end">
      <button class="no-btn" @click="close('saveDraft')">{{ $t("OrderPage[\"Save as Draft\"]") }}</button>
      <button class="yes-btn" @click="close('saveAddressBtn')">{{ $t("OrderPage[\"Fill Address\"]") }}</button>
    </span>
    </template>
  </el-dialog>
</template>

<script>
import { updatePatientApi } from "@/api/va-order-page/orderTest.js";

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: true,
    },
    isSelectedTaxableTest: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      isIntrestPopup: false,
    };
  },

  watch: {
    isShowDialog(newVal) {
      this.dialogVisible = newVal;
    },
  },
  methods: {
    close(action) {
      if(action==="saveDraft") {
        this.$emit('close')
        let ele = document.getElementById("save-draft-btn")
        ele.click()
      }
      else if(action === 'saveAddressBtn') {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.inform-text {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* .country-input-box {
  width: 150px;
  border-radius: 5px;
  border: 1px solid var(--base-black, #424242);
  background: #FFF;
  margin-right: 24px;
}

.address-input-box {
  width: 324px;
  border-radius: 5px;
  border: 1px solid var(--base-black, #424242);
  background: #FFF;
}

.input-title {
  display: flex;
  padding: 5px 10px;
} */

.no-btn{
  height: 42px;
  background: #E6E6E6;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  letter-spacing: 0.429px;
  color: #000000;
  margin-right: 17px;
  border-radius: 4px;
  padding: 8px 20px;
}

.yes-btn{
  height: 42px;
  background: #20A8C3;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  letter-spacing: 0.429px;
  color: #FFFFFF;
  border-radius: 4px;
  padding: 8px 20px;
}

.span-icon {
  color: #F00;
  /* font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; */
}

.line {
  border-bottom: 1px solid #E6E6E6;
}

.title {
  color: var(--Base-Black, #000);
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.15px;
}
</style>